import { render, staticRenderFns } from "./Gramophone.vue?vue&type=template&id=d250392e&"
import script from "./Gramophone.vue?vue&type=script&lang=js&"
export * from "./Gramophone.vue?vue&type=script&lang=js&"
import style0 from "./Gramophone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports